import {Component, inject} from '@angular/core';
import {ModalRef} from '@shared/components/modal/modal.ref';
import {MODAL_CONFIG} from '@shared/components/modal/modal.token';
import {ModalConfig} from '@shared/components/modal/modal.config';
import {ICompanyRemovalEligibility} from '@models/company.interface';

@Component({
  selector: 'app-company-remove-dialog',
  templateUrl: './company-remove-dialog.html',
})
export class CompanyRemoveDialog {
  private readonly modalRef = inject(ModalRef<boolean>);
  private readonly config = inject<ModalConfig | null>(MODAL_CONFIG, {optional: true});

  companyName(): string {
    return this.config?.data?.companyName || 'cette entreprise';
  }

  eligibility(): ICompanyRemovalEligibility | null {
    return this.config?.data?.eligibility ?? null;
  }

  canRemove(): boolean {
    return this.eligibility()?.canRemove ?? true;
  }

  confirm(): void {
    if (!this.canRemove()) {
      return;
    }
    this.modalRef.close(true);
  }

  cancel(): void {
    this.modalRef.close(false);
  }
}
